import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IconColor, IconSize, IconType } from '../../common/constants/icon-config';
import { IconNames } from '../../common/constants/icon-names';
import { S_CODE_ICONS, SCode } from '../../common/constants/scode-status';
import { Tracking } from '../../store/models';
import { StatusAcceptanceType } from '../../store/constants';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { DateWithTimezoneComponent } from '../timezone/date-with-timezone.component';
import { TooltipAlertComponent } from '../tooltip/alert/tooltip-alert.component';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-horizontal-status-tracking',
  imports: [
    CommonModule,
    TooltipAlertComponent,
    IntrackFeatureModule,
    TranslateModule,
    DateWithTimezoneComponent,
    SvgIconComponent,
  ],
  templateUrl: './horizontal-status-tracking.component.html',
  styleUrls: ['./horizontal-status-tracking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalStatusTrackingComponent {
  @Input() statuses: Tracking[];
  // TODO remove after DN/HU implementation
  @Input() isTimezoneAvailable = true;

  iconType = IconType;
  iconSize = IconSize;
  iconColor = IconColor;
  sCodeIcons: Map<SCode, IconNames> = S_CODE_ICONS;
  browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  dateFormat: string;
  acceptanceType = StatusAcceptanceType;
}
